import { render, staticRenderFns } from "./mainuser.vue?vue&type=template&id=bfce26c2&scoped=true"
import script from "./mainuser.vue?vue&type=script&lang=js"
export * from "./mainuser.vue?vue&type=script&lang=js"
import style0 from "./mainuser.vue?vue&type=style&index=0&id=bfce26c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfce26c2",
  null
  
)

export default component.exports